import React from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { Task } from '../../../types';
import { TaskFormWrapper } from './TaskFormWrapper';

interface ExpertWitnessFormProps {
  task: Task;
  onSubmit: (formData: any) => void;
}

export const ExpertWitnessForm: React.FC<ExpertWitnessFormProps> = ({
  task,
  onSubmit
}) => {
  const [formData, setFormData] = React.useState({
    expertName: '',
    expertise: '',
    availability: dayjs(),
    meetingType: '',
    meetingLocation: '',
    scopeOfTestimony: '',
    estimatedDuration: '',
    specialRequirements: '',
  });

  const handleChange = (field: string, value: any) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <TaskFormWrapper task={task} onSubmit={() => onSubmit(formData)}>
      <TextField
        label="Expert Name"
        fullWidth
        value={formData.expertName}
        onChange={(e) => handleChange('expertName', e.target.value)}
      />

      <TextField
        label="Area of Expertise"
        fullWidth
        value={formData.expertise}
        onChange={(e) => handleChange('expertise', e.target.value)}
      />

      <DatePicker
        label="Availability"
        value={formData.availability}
        onChange={(date) => handleChange('availability', date)}
        slotProps={{
          textField: { fullWidth: true }
        }}
      />

      <FormControl fullWidth>
        <InputLabel>Meeting Type</InputLabel>
        <Select
          value={formData.meetingType}
          label="Meeting Type"
          onChange={(e) => handleChange('meetingType', e.target.value)}
        >
          <MenuItem value="in-person">In Person</MenuItem>
          <MenuItem value="video">Video Conference</MenuItem>
          <MenuItem value="phone">Phone Call</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Meeting Location/Details"
        fullWidth
        value={formData.meetingLocation}
        onChange={(e) => handleChange('meetingLocation', e.target.value)}
      />

      <TextField
        label="Scope of Testimony"
        fullWidth
        multiline
        rows={3}
        value={formData.scopeOfTestimony}
        onChange={(e) => handleChange('scopeOfTestimony', e.target.value)}
      />

      <TextField
        label="Estimated Duration"
        fullWidth
        value={formData.estimatedDuration}
        onChange={(e) => handleChange('estimatedDuration', e.target.value)}
      />

      <TextField
        label="Special Requirements"
        fullWidth
        multiline
        rows={2}
        value={formData.specialRequirements}
        onChange={(e) => handleChange('specialRequirements', e.target.value)}
      />
    </TaskFormWrapper>
  );
};